import React from "react";
import { useFetch } from "@/lib/api";
import { PageHero } from "@/components/blocks/PageHero";
import { Reveal } from "@/components/blocks/Reveal";
import { LeaderCard } from "@/components/cards/Cards";
import { EmptyState } from "@/components/blocks/EmptyState";
import { Users } from "lucide-react";

const Leadership = () => {
  const { data: leaders } = useFetch("/leadership");

  return (
    <div>
      <PageHero
        overline="Leadership"
        title="Servants of the Gospel"
        subtitle="Meet the leadership carrying the mandate of Flames of Fire World Evangelism."
        image="https://images.unsplash.com/photo-1497621122273-f5cfb6065c56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="bg-white py-24 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          {leaders && leaders.length > 0 ? (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {leaders.map((l, i) => (
                <Reveal key={i} delay={i * 0.05}>
                  <LeaderCard leader={l} />
                </Reveal>
              ))}
            </div>
          ) : (
            <EmptyState icon={Users} title="Leadership profiles coming soon" description="Official leadership details will be published here." />
          )}
        </div>
      </section>
    </div>
  );
};

export default Leadership;
